{
  "#PALETTENKORREKTUR": {}
}
